import { RequestTre, ResponseTre } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { TreActions } from '../actions';
import { TreTypes } from '../../shared/enums';

export interface TreState {
    response: ResponseTre;
    request: {};
    error: any;
}

export const TreState: TreState = {
    response: null,
    request: null,
    error: null
};

const _validateSessioReducer = createReducer(
    TreState,

    on(TreActions.getTre, (state) => ({
        ...state,
        request: null,
        error: null
    })),

    on(TreActions.getTreSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(TreActions.getTreError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(TreActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function TreReducer(state, action) {
    if (action.type === TreTypes.TRE) {
        state = undefined;
    }
    return _validateSessioReducer(state, action);
}
